// extracted by mini-css-extract-plugin
export var container = "styles-module__container___c0L_q";
export var imageContainer = "styles-module__imageContainer___DAhdN";
export var listImage = "styles-module__listImage___KqOE2";
export var name = "styles-module__name___Zo9Mv";
export var contains = "styles-module__contains___UAko_";
export var favoriteButtonContainer = "styles-module__favoriteButtonContainer___XDiTy";